var map = {
	"./Paper1/PP1-M.png": 92,
	"./Paper2/PP2-M.png": 93,
	"./Paper3/PP3-M.png": 94,
	"./Paper4/PP4-M.png": 95,
	"./Paper5/PP5-M.png": 96,
	"./Paper6/PP6-M.png": 97,
	"./Paper7/PP7-M.png": 98,
	"./Paper8/PP8-M.png": 99
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 322;


//////////////////
// WEBPACK FOOTER
// ./src/Assets ^\.\/Paper.*\-M\.png$
// module id = 322
// module chunks = 0